import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscCheckpoint = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 1-.067v2.015a9.962 9.962 0 0 1-8.071-2.877A10 10 0 0 1 12 2v2ZM19.5 15v2.5H22v2h-2.5V22h-2v-2.5H15v-2h2.5V15h2Z"
    />
    <path
      fill="#88827E"
      d="m13 12.47-3.93 3.3-1.29-1.53L11 11.53V7h2v5.47ZM20.52 9.27a1.252 1.252 0 0 1 1.45 1 1.25 1.25 0 0 1-1 1.45 1.25 1.25 0 0 1-1.45-1 1.25 1.25 0 0 1 1-1.45ZM18.839 4.512a1.24 1.24 0 0 1 1.241.608 1.25 1.25 0 0 1-.919 1.868 1.24 1.24 0 0 1-1.366-1.558 1.253 1.253 0 0 1 1.044-.918ZM14.95 2.003c.163-.006.326.02.48.077a1.242 1.242 0 0 1 .817 1.12 1.24 1.24 0 0 1-.077.48 1.24 1.24 0 0 1-1.6.74 1.242 1.242 0 0 1-.817-1.12 1.24 1.24 0 0 1 .077-.48 1.24 1.24 0 0 1 1.12-.817Z"
    />
  </svg>
);
export default SvgMiscCheckpoint;
